import React from "react";
const SvgMapVisualization = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <g fill="#000" fillRule="evenodd" clipRule="evenodd">
      <path d="M11.497 3.637a.995.995 0 011.006 0L20.5 8.318a1.018 1.018 0 01-.033 1.772l-7.996 4.292a.994.994 0 01-.942 0L3.532 10.09A1.018 1.018 0 013.5 8.318l7.997-4.681zm.503.876L4.003 9.195 12 13.487l7.997-4.292L12 4.513z" />
      <path d="M6.41 12.752a.5.5 0 01-.187.682L4 14.701l8 4.233 7.999-4.233-2.222-1.267a.5.5 0 01.495-.868l2.223 1.267a1 1 0 01-.028 1.752l-8.233 4.357a.5.5 0 01-.468 0l-8.234-4.357a1 1 0 01-.027-1.752l2.223-1.267a.5.5 0 01.682.186z" />
    </g>
  </svg>
);
export default SvgMapVisualization;
